// extracted by css-extract-rspack-plugin
export default {"loader":"Preloader-module__loader___UXd1p","loader-spinner":"Preloader-module__loader-spinner___sgmyS","loaderSpinner":"Preloader-module__loader-spinner___sgmyS"};